module.exports = __webpack_public_path__ + "img/02—01—01—IP settings > Inline warning.ec8b533b.jpg";